import { useAuth } from './useAuth';
import {
  can,
  isAdmin,
  canManageMembers,
  canManageRoles,
  getUserPermissions,
  canNavigateModule,
  canCreateInModule,
  canEditInModule,
  canDeleteInModule,
} from '../utils/permissions';

/**
 * Hook para verificar permissões do usuário (single-tenant).
 */
export const usePermissions = () => {
  const { user } = useAuth();

  return {
    can: permissionKey => can(user, permissionKey),
    isAdmin: () => isAdmin(user),
    canManageMembers: () => canManageMembers(user),
    canManageRoles: () => canManageRoles(user),
    getUserPermissions: () => getUserPermissions(user),
    canNavigateModule: moduleKey => canNavigateModule(user, moduleKey),
    canCreateInModule: moduleKey => canCreateInModule(user, moduleKey),
    canEditInModule: moduleKey => canEditInModule(user, moduleKey),
    canDeleteInModule: moduleKey => canDeleteInModule(user, moduleKey),
    user,
  };
};

/**
 * Hook específico para verificar se pode gerenciar membros
 */
export const useCanManageMembers = () => {
  const { canManageMembers } = usePermissions();
  return canManageMembers();
};

/**
 * Hook específico para verificar se é admin
 */
export const useIsAdmin = () => {
  const { isAdmin } = usePermissions();
  return isAdmin();
};

// Removido: hooks de áreas (módulo de áreas indisponível)
